
<template>
    <div class="main-content" id="panel">
      <!-- Header -->
      <!-- <Header /> -->
      <!-- Header -->
      <div class="header bg-primary pb-6">
        <div class="container-fluid">
          <div class="header-body">
            <div class="row align-items-center py-4">
              <div class="col-lg-6 col-7">
                <h2>Import Ticket</h2>
              </div>
              <!-- <div class="col-lg-6 col-5 text-right">
                <button type="button" @click="ticketProcess()" class="btn btn-warning rounded ml-1">
                      <i v-if="!processing" class="fas fa-download"></i> 
                      
                      <span v-if="!processing">PROCESS</span>
                      
                    </button>
              </div> -->
            </div>
            <!-- Card stats -->
          </div>
        </div>
      </div>
      <!-- Page content -->
      <div class="container-fluid mt--6">
        <div class="row justify-content-md-center upload">
          <div class="col-xl-8">
            <div class="card">
              <div class="card-header bg-transparent">
                <div class="row align-items-center">
                  <div class="col">
                    <h3>UPLOAD FILES</h3>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="chart">
                  <p id="files-area">
                    <span id="filesList">
                      <span id="files-names" v-for="(file,i) in files" :key="file.name">
                        <span class="file-block">
                          <span class="file-delete" @click="removeFile(i)">
                            <span>+</span>
                          </span>
                          <span class="name" style="margin:5px">{{file.name}}</span>
                        </span>
                      </span>
                    </span>
                  </p>
                  <div class="d-flex" style="justify-content:center;margin-top: 30px;" v-if="files.length">
                    <div class="col-lg-6">
                      <label>Trade Date</label>
                      <datepicker v-model="tradeDate" placeholder="mm/dd/yyyy"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" typeable :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                  </div>
                  <!-- <div class="d-flex">
                    <div class="card" style="width:120px" v-for="(file,i) in files" :key="file.name">
                        <div style="font-size:45px">
                          <i class="fas fa-file-image"></i>
                        </div>
                        <div class="card-body preview-body">
                          <h4 class="card-title">{{file.name}}</h4>
                          <button @click="removeFile(i)" class="btn btn-danger">Delete</button>
                        </div>
                    </div>
                  </div> -->
                  <span v-if="(files.length == 0)" class="round"><img src="../../assets/img/vector/upload-csv01.png" alt /></span>
                  <progress v-if="uploadPercentage && !fileUploadSuccess" max="100" :value.prop="uploadPercentage"></progress><br>

                  <label v-if="(files.length != 0) && tradeDate"  class="btn btn-success my-2" @click="uploadFiles()">
                    <i v-if="!fileUploadInprogress" class="fas fa-cloud-upload-alt"></i>
                    <i v-if="fileUploadInprogress" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                    Upload
                  </label>
                  <label v-if="(files.length != 0)"  class=" btn btn-danger my-2" @click="removeFiles()">
                    <i class="fas fa-trash"></i>
                    Clear
                  </label>
                  <label v-if="(files.length == 0)"  for="file-upload" class="custom-file-upload btn btn-primary my-2">
                    <i class="fas fa-folder-open"></i>
                    Browse...
                  </label>
                  <input id="file-upload" type="file" multiple @change="selectFiles('input')" />
                  <div  v-if="fileUploadSuccess" class="import-success">
                    <h4 class="text-success"><i class="fas fa-check"></i> Files uploaded successfully.</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Footer -->
        <!-- <Footer /> -->
      </div>
    </div>
  </template>
  
  <script>
  import AWS from 'aws-sdk/global';
  import config from "@/config";
  //import this.$http from "this.$http";
  // import Header from "../common/Header";
  // import Footer from "../common/Footer";
  import authService from "@/authService";
  import Datepicker from 'vuejs-datepicker';

  export default {
    name: "HomePage",
    components: {
      Datepicker
      // Header,
      // Footer
    },
    data() {
      return {
        user: {},
        accessToken: null,
        error: null,
        loading: false,
        selectedFileCount : 0,
        uploadedFileCount : 0,
        files : [],
        fileUploadSuccess : false,
        fileUploadInprogress : false,
        uploadPercentage : 0,
        processing : false,
        tradeDate: new Date()
      };
    },
    methods: {
      ticketProcess(){
        var message = `Are you sure you want to process uploaded files?`;
          this.$confirm(message,"Process","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
            let addData = {"mode": "PROCESS" ,"cognitoSub" : authService.getUser().cognitoSub};
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()}
            };
            this.$http
            .post(config.baseUrlBidSide + "/ticket-catalogue/process", addData, auth)
            .then(() => {
                this.loading = false;  
                this.$alert("Processing Started","","success");
                // this.$emit('close');               
            })
            .catch(() => {
                this.loading = false;              
            });
            
          });
      },
      uploadFiles(){
        if(!this.fileUploadInprogress){
          var message = `Are you sure you want to upload ${this.selectedFileCount} files?`;
          this.$confirm(message,"Upload","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
            this.upload();
          });
        }
      },
      removeFiles(){
        this.files = [];
      },
      removeFile(index){
        const dt = new DataTransfer()
        const input = document.getElementById('file-upload')
        const { files } = input
        
        for (let i = 0; i < files.length; i++) {
          const file = files[i]
          if (index !== i)
            dt.items.add(file) // here you exclude the file. thus removing it.
        }
        
        input.files = dt.files // Assign the updates list;

        this.files = input.files;
        document.getElementById("file-upload").files = input.files;
        this.selectedFileCount = this.files.length;

      },
      resetToDefault(){
        this.files = [];
        this.selectedFileCount = 0;
        this.uploadedFileCount = 0;
        this.uploadPercentage = 0;

      },
      selectFiles(){
        this.fileUploadSuccess = false;
        this.files = document.getElementById("file-upload").files;
        if (!this.files.length) {
          return alert("Please choose a file to upload first.");
        }
        this.selectedFileCount = this.files.length;
      },
      upload() {
        var s3 = new AWS.S3({
        apiVersion: "2006-03-01",
        params: { Bucket: "imsfileupload"}
        });
        var files = document.getElementById("file-upload").files;
        if (!files.length) {
        return alert("Please choose a file to upload first.");
        }
        let self = this;
        this.selectedFileCount = files.length;
        this.uploadedFileCount = 0
        for (let index = 0; index < files.length; index++) {
          console.log("inloop")
          const file = files[index];
          var imsFolderName = "/ticket_catalogue/to_be_processed/"+authService.getUser().cognitoSub+"/"+this.moment(this.tradeDate).format("YYYY-MM-DD");
          var albumBucketName = config.albumBucketNameIms+imsFolderName;
          self.fileUploadInprogress = true;
          s3.upload(
            { Key: file.name, Bucket: albumBucketName, Body: file, ACL: "private" },
            function(err) {
              if (err) { console.log("err")} else {
                self.uploadedFileCount++ ; 
                self.uploadPercentage = parseInt( Math.round( ( self.uploadedFileCount / self.selectedFileCount) * 100))
                if(self.uploadedFileCount == self.selectedFileCount){
                  self.fileUploadInprogress = false;
                  self.fileUploadSuccess = true;
                  self.resetToDefault();
                  self.$router.push("/ticketsystem/unprocessed");
                }

              }
            }
            );
          
        }
      }
    },
    mounted() {
      this.$cognitoAuth.getIdToken((err, result) => {
          if (err) {
              console.log("accessToken is not found", err);
          } else {
              this.accessToken = result;
          }
      });
      const userPoolLoginKey = config.userPoolLoginKey;
      const logins = {};
      logins[userPoolLoginKey] = this.accessToken;
      AWS.config.region = config.region;
      const cognitoParams = {
          IdentityPoolId: config.IdentityPoolIdFileUpload,
          Logins: logins
      };
      let cognitoidentity = new AWS.CognitoIdentity();
      cognitoidentity.getId(cognitoParams, function(err, data) {
          if (err) {
              console.log(err);
          } else {
              console.log(data.IdentityId);
              let bucketRegion = AWS.config.region;
              AWS.config.update({
              region: bucketRegion,
              credentials: new AWS.CognitoIdentityCredentials(cognitoParams)
              });
          }
      });
      
    }
  };
  </script>
  <style scoped>
  .preview-body{
    padding: 0.5rem !important;
  }
  #files-area{
    margin: 0 auto;
  }
  .file-block{
    border-radius: 10px;
    background-color: rgba(144, 163, 203, 0.2);
    margin: 5px;
    color: initial;
    display: inline-flex;
  }
  .file-block.span.name{
		padding-right: 10px;
		width: max-content;
		display: inline-flex;
    margin: 5px;
	}
  .file-delete{
    display: flex;
    width: 24px;
    color: initial;
    background-color: #6eb4ff00;
    font-size: large;
    justify-content: center;
    margin-right: 3px;
    cursor: pointer;
  }
  .file-delete:hover{
		background-color: rgba(144, 163, 203, 0.2);
		border-radius: 10px;
	}
	.file-delete > span{
		transform: rotate(45deg);
	}

  </style>